import { render, staticRenderFns } from "./UnitSelectResourceful.vue?vue&type=template&id=31b57cc2&"
import script from "./UnitSelectResourceful.vue?vue&type=script&lang=js&"
export * from "./UnitSelectResourceful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports